<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    customClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    classes() {
      return "py-3 card " + this.customClass;
    },
  },
};
</script>
